<template>
  <div v-show="showAround" class="around-com">
    <div class="title">楼盘周边</div>
    <div class="map-wrap">
      <baidu-map class="bm-view" :center="center" :zoom="zoom" @ready="handler">

        <bm-marker
          v-for="(item, index) in myMarkers"
          :position="item.position"
          :key="index"
          @click="infoWindowOpen(item, index)">
          <bm-info-window :show="item.showLabel" @close="closeLabel(item)">
            <p>{{item.title}}</p>
            <p class="address">{{item.address}}</p>
            <div class="pos-detail" @click="goMap(item)">详情>></div>
          </bm-info-window>
        </bm-marker>
      </baidu-map>
      <div class="around-list">
        <div class="type-list">
          <div v-for="(item, index) in aroundList" :key="index" :class="{active: active === index}" @click="changeType(item, index)">
            {{ item.name }}
          </div>
        </div>
        <div class="address-list">
          <div class="address-wrap"
            v-for="(sub, j) in itemAroundList"
            :key="j"
            :class="{active: sub.active}"
            @click="choseAround(j)"
          >
            <div class="left">
              <p>{{sub.title}}</p>
              <p>{{sub.address}}</p>
            </div>
            <div class="right">{{ dataFormat(sub, 'journey') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'around-com',
  props: {
    projectCode: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      showAround: true,
      aroundList: [],
      itemAroundList: [],
      active: 0,
      navJourney: null,
      marker: null, // 地图图层
      center: {
        lng: 0,
        lat: 0,
      },
      zoom: 14,
      myMarkers: [],
      activeIndex: null,
    }
  },
  computed: {
    ...mapGetters(['projectDetail'])
  },
  methods: {
    goMap (pos) {
      window.location.href = `http://api.map.baidu.com/geocoder?address=${pos.title}&output=html&key=Y5NuypCulukvKc5UGlerfnyhcFzfnwYU`
    },
    infoWindowOpen (item, index) {
      this.myMarkers.forEach(sub => {
        sub.showLabel = item.id === sub.id
      })
      this.activeIndex = index
      this.center.lat = item.position.lat
      this.center.lng = item.position.lng
      const id = item.id
      this.itemAroundList.forEach((around) => {
        around.active = around.id === id
      })
    },
    closeLabel (item) {
      const id = item.id
      this.itemAroundList.forEach((around) => {
        if (around.id === id) {
          around.active = false
        }
      })
    },
    choseAround (index) {
      this.itemAroundList.forEach((item, i) => {
        item.active = index === i
      })
      const id = this.itemAroundList[index]?.id
      this.myMarkers.forEach((mark, i) => {
        if (mark.id === id) {
          this.activeIndex = i
          mark.showLabel = true
          this.center.lat = mark.position.lat
          this.center.lng = mark.position.lng
        } else {
          mark.showLabel = false
        }
      })
    },
    handler () {
      const latitudeAndLongitude = this.info.latitudeAndLongitude || this.$route.query.latitudeAndLongitude
      const latLogList = latitudeAndLongitude.split(',')
      this.center.lat = latLogList[0]
      this.center.lng = latLogList[1]
      this.getProjectArundList()
    },
    dataFormat (item, type) {
      let dataFormat
      if (type === 'journey') {
        dataFormat = 'journey' in item
          ? item.journey
            ? item.journey > 1000
              ? (item.journey / 1000).toFixed(1) + 'km'
              : item.journey + 'm'
            : '999km' : null
      }
      if (type === 'duration') {
        dataFormat = 'duration' in item ? item.duration
          ? item.duration > 60
            ? (item.duration / 60).toFixed(1) + '小时'
            : item.duration + '分钟'
          : '99小时' : null
      }
      if (type === 'navJourney') {
        const navJourney = this.navJourney
        dataFormat = navJourney
          ? navJourney > 1000
            ? (navJourney / 1000).toFixed(1) + 'km'
            : navJourney + 'm'
          : '999km'
      }
      return dataFormat
    },
    changeType (item, index) {
      this.active = index
      this.itemAroundList = item.map
      for (let item of this.itemAroundList) {
        this.$set(item, 'active', false)
      }
      this.myMarkers = []
      this.$nextTick(() => {
        this.renderMarker()
      })
    },
    getProjectArundList () {
      this.$api.getProjectArundList({ projectCode: this.projectCode}).then(res => {
        if (res.code === 200 && res.data.length) {
          this.aroundList = res.data.filter(item => {
            return item.map.length
          })
          this.itemAroundList = this.aroundList[0]?.map
          for (let item of this.itemAroundList) {
            this.$set(item, 'active', false)
          }
          this.renderMarker()
        } else {
          this.showAround = false
        }
      })
    },
    // 将坐标点处理为地图可以识别的坐标
    renderMarker() {
      let myMarkers = []
      this.itemAroundList.map((item) => {
        let obj = {
          id: item.id,
          position: {lat: item.lat * 1, lng: item.lng * 1},
          title: `${item.title}`,
          showLabel: false,
          address: item.address
        }
        myMarkers.push(obj)
      })
      this.myMarkers = myMarkers
    },
  }
}
</script>
<style lang="scss" scoped>
.around-com{
  margin-bottom: 120px;
  .title{
    @include font24(bold, #333333);
    margin: 52px 0 16px 0;
  }
  .map-wrap{
    width: 100%;
    height: 397px;
    border: 1px solid #BDA26C;
    display: flex;
    justify-content: flex-start;
    .bm-view{
      width: 60%;
      height: 100%;
      cursor: pointer;
      .address{
        max-width: 400px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 12px;
        line-height: 17px;
        font-weight: 400;
        color: #9399A5;
      }
      .pos-detail{
        margin-top: 10px;
        color: #BDA26C;
        cursor: pointer;
      }
    }
    .around-list{
      width: 40%;
      height: 100%;
      border-left: 1px solid #BDA26C;
      .type-list{
        display: flex;
        div {
          flex: 1;
          height: 54px;
          background: #F9F9F9;
          @include font14(500, #333);
          line-height: 54px;
          text-align: center;
          cursor: pointer;
        }
        .active{
          background: #BDA26C;
          color: white;
        }
      }
      .address-list{
        width: 100%;
        height: 340px;
        overflow: auto;
        .address-wrap{
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 70px;
          background: #fff;
          padding: 0 33px;
          box-sizing: border-box;
          .left{
            width: 80%;
            p:nth-child(1){
              @include font14(400, #333);
            }
            p:nth-child(2){
              @include font12(400, #9399A5);
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .right{
            width: 20%;
            text-align: center;
          }
        }
        .active{
          background: #BDA26C;
          color: white;
          .left{
            p{
              color: white !important;
            }
          }
        }
      }
    }
  }
}
</style>
